import { EventBroker } from "../../../lib/utils/event-broker";

export const EVENTS = {
    INIT: 'INIT',
    CLOSE: 'CLOSE',
    REPLACE: 'REPLACE',
}

export const replaceTextHandlerEventBroker = new EventBroker();